import type { AttachmentInput } from '../types/vipMp';

function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => {
      const s = String(fr.result || '');
      const i = s.indexOf(',');
      resolve(i >= 0 ? s.substring(i + 1) : s);
    };
    fr.onerror = () => reject(fr.error);
    fr.readAsDataURL(file);
  });
}

export async function encodeAttachmentsForApi(
  items: AttachmentInput[]
): Promise<
  Array<{
    fileName: string;
    fileType: string | null;
    fileUrl?: null;
    storageReference?: null;
    fileContentBase64: string;
    contentType: string;
  }>
> {
  const out: Array<{
    fileName: string;
    fileType: string | null;
    fileUrl?: null;
    storageReference?: null;
    fileContentBase64: string;
    contentType: string;
  }> = [];
  for (const row of items) {
    const name = row.file.name || 'file';
    const ext = name.includes('.') ? name.split('.').pop() || '' : '';
    const b64 = await readFileAsBase64(row.file);
    out.push({
      fileName: name,
      fileType: ext ? `.${ext}` : null,
      fileUrl: null,
      storageReference: null,
      fileContentBase64: b64,
      contentType: row.file.type || 'application/octet-stream'
    });
  }
  return out;
}
